module.exports = __webpack_public_path__ + "img/red.8b9d32b.png";